import { CircleUser, Sparkles, SquareMenu } from 'lucide-react';

import { ContextMenu } from '@/shared/components/context-menu';
import { Separator } from '@/shared/components/shadcn/separator';
import { showContextMenu } from '@/shared/utils/show-context-menu';
import { setInsightScrollTop } from '../../insight-layout/hook/use-insight-scroll-container';

export type DrillDownContextMenuAction = 'view-posts' | 'view-profiles' | 'ask-syncly';

export interface ShowDrillDownContextMenuOptions {
  position: { x: number; y: number };
  menus?: DrillDownContextMenuAction[];
}

export function showDrillDownContextMenu({
  position,
  menus = ['view-posts', 'view-profiles'],
}: ShowDrillDownContextMenuOptions): Promise<DrillDownContextMenuAction | 'close'> {
  return new Promise((resolve) => {
    showContextMenu({
      position,
      className: 'w-73',
      children: (
        <>
          {menus.includes('view-posts') && (
            <ContextMenu.Item
              icon={<SquareMenu className="size-4" />}
              onClick={() => {
                setInsightScrollTop();
                resolve('view-posts');
              }}
            >
              View posts
            </ContextMenu.Item>
          )}
          {menus.includes('view-profiles') && (
            <ContextMenu.Item
              icon={<CircleUser className="size-4" />}
              onClick={() => {
                setInsightScrollTop();
                resolve('view-profiles');
              }}
            >
              View profiles
            </ContextMenu.Item>
          )}
          {menus.includes('ask-syncly') && (
            <>
              <Separator className="my-1" />
              <ContextMenu.Item
                icon={<Sparkles className="size-4" />}
                onClick={() => {
                  setInsightScrollTop();
                  resolve('ask-syncly');
                }}
              >
                Ask Syncly
              </ContextMenu.Item>
            </>
          )}
          {/* TODO: Add back in when we have a filter */}
          {/* <ContextMenu.Separator />
          <ContextMenu.Item
            icon={<ListFilter className="size-4" />}
            onClick={() => resolve('add-to-filter')}
          >
            Add to filter
          </ContextMenu.Item> */}
        </>
      ),
    }).then(() => {
      // If the promise resolves without any click (e.g., ESC key, outside click)
      resolve('close');
    });
  });
}
